/* muni yeni nesil — small behaviours for muni-* sections. No dependencies. */
(function () {
  var html = document.documentElement;

  /* ---------- header height (hero fills the rest of the first screen) ---------- */
  function setHeaderHeight() {
    var h = 0;
    document.querySelectorAll('[data-muni-measure]').forEach(function (el) { h += el.offsetHeight; });
    if (h) html.style.setProperty('--muni-hdr-h', h + 'px');
  }
  window.addEventListener('resize', setHeaderHeight);
  document.addEventListener('DOMContentLoaded', setHeaderHeight);
  document.addEventListener('shopify:section:load', setHeaderHeight);

  /* ---------- community panel ---------- */
  function panelFor(btn) { return document.getElementById(btn.getAttribute('aria-controls')); }
  function closePanels(except) {
    document.querySelectorAll('[data-muni-panel-toggle]').forEach(function (b) {
      var p = panelFor(b);
      if (p && p !== except) { p.hidden = true; b.setAttribute('aria-expanded', 'false'); }
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-muni-panel-toggle]');
    if (t) {
      var p = panelFor(t);
      if (!p) return;
      var open = p.hidden;
      closePanels(p);
      p.hidden = !open;
      document.querySelectorAll('[aria-controls="' + p.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      return;
    }
    if (e.target.closest('[data-muni-panel-close]')) { closePanels(null); return; }
    if (!e.target.closest('.muni-panel')) closePanels(null);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanels(null); });

  /* ---------- theme toggle (preview button, optional) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-muni-theme-toggle]');
    if (!b) return;
    var t = html.getAttribute('data-muni-theme') === 'navy' ? 'green' : 'navy';
    html.setAttribute('data-muni-theme', t);
    try { sessionStorage.setItem('muni-tema', t); localStorage.setItem('muni-tema-son', t); } catch (err) {}
    refreshVideos();
    var l = b.querySelector('[data-label]');
    if (l) l.textContent = t === 'navy' ? l.getAttribute('data-navy') : l.getAttribute('data-green');
  });

  /* ---------- theme-dependent videos: only the visible one plays ---------- */
  function refreshVideos() {
    document.querySelectorAll('.muni video').forEach(function (v) {
      var visible = v.offsetParent !== null;
      if (visible) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else { try { v.pause(); } catch (err) {} }
    });
  }
  document.addEventListener('DOMContentLoaded', refreshVideos);
  document.addEventListener('shopify:section:load', refreshVideos);

  /* ---------- product carousel ---------- */
  function initCarousel(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var cards = Array.prototype.slice.call(root.querySelectorAll('.muni-car__card'));
    var n = cards.length, i = 0;
    if (!n) return;
    function render() {
      cards.forEach(function (c, k) {
        var d = ((k - i) % n + n) % n;
        if (d > n / 2) d -= n;
        if (n <= 2) d = k - i;
        c.dataset.pos = Math.abs(d) <= 2 ? String(d) : 'hide';
        c.style.order = String(d + 10);
        c.tabIndex = d === 0 ? 0 : -1;
      });
    }
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches, busy = false;
    function go(step) {
      if (busy) return;
      if (reduce) { i += step; render(); return; }
      busy = true;
      var first = cards.map(function (c) { return c.dataset.pos === 'hide' ? null : c.getBoundingClientRect(); });
      i += step; render();
      cards.forEach(function (c, k) {
        if (c.dataset.pos === 'hide') return;
        var last = c.getBoundingClientRect(), f = first[k];
        c.style.transition = 'none';
        if (f) {
          c.style.transformOrigin = '0 0';
          c.style.transform = 'translate(' + (f.left - last.left) + 'px,' + (f.top - last.top) + 'px) scale(' + (f.width / last.width) + ',' + (f.height / last.height) + ')';
        } else {
          c.style.transformOrigin = '50% 50%';
          c.style.transform = 'translateX(' + (step > 0 ? 60 : -60) + 'px) scale(.7)';
          c.style.opacity = '0';
        }
      });
      root.offsetWidth; // flush
      cards.forEach(function (c) {
        if (c.dataset.pos === 'hide') return;
        c.style.transition = 'transform .42s cubic-bezier(.34,1.4,.64,1), opacity .3s ease';
        c.style.transform = ''; c.style.opacity = '';
      });
      setTimeout(function () { cards.forEach(function (c) { c.style.transition = ''; c.style.transformOrigin = ''; }); busy = false; }, 440);
    }
    var prev = root.querySelector('.muni-car__prev'), next = root.querySelector('.muni-car__next');
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    root.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') go(-1); if (e.key === 'ArrowRight') go(1); });
    var sx = null, moved = false;
    root.addEventListener('pointerdown', function (e) { if (e.target.closest('.muni-arrow')) return; sx = e.clientX; moved = false; });
    root.addEventListener('pointermove', function (e) { if (sx !== null && Math.abs(e.clientX - sx) > 8) moved = true; });
    root.addEventListener('pointerup', function (e) { if (sx === null) return; var dx = e.clientX - sx; sx = null; if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1); });
    root.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    root.addEventListener('dragstart', function (e) { e.preventDefault(); });
    render();
  }
  function initAll() { document.querySelectorAll('[data-muni-carousel]').forEach(initCarousel); document.querySelectorAll('[data-muni-gallery]').forEach(initGallery); document.querySelectorAll('[data-muni-buy]').forEach(initBuy); loadRelated(); }
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);

  /* ---------- product gallery ---------- */
  function initGallery(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var main = root.querySelector('.muni-gal__main img'), count = root.querySelector('[data-count]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.muni-thumb'));
    var n = thumbs.length, i = 0;
    if (!main || !n) return;
    function show(k) {
      i = (k % n + n) % n;
      var t = thumbs[i];
      main.src = t.dataset.src; main.srcset = t.dataset.srcset || ''; main.alt = t.dataset.alt || '';
      thumbs.forEach(function (x, j) { x.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      if (count) count.textContent = (i + 1) + ' / ' + n;
    }
    thumbs.forEach(function (t, j) { t.addEventListener('click', function () { show(j); }); });
    var p = root.querySelector('[data-prev]'), q = root.querySelector('[data-next]');
    if (p) p.addEventListener('click', function () { show(i - 1); });
    if (q) q.addEventListener('click', function () { show(i + 1); });
  }

  /* ---------- buy box: quantity, total, variant ---------- */
  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2).split('.');
    var whole = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var amt = whole + ',' + v[1];
    return fmt ? fmt.replace(/\{\{\s*\w+\s*\}\}/, amt) : amt + ' TL';
  }
  function initBuy(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var fmt = root.dataset.moneyFormat || '';
    var qty = root.querySelector('input[name="quantity"]');
    var total = root.querySelector('[data-total]');
    var idInput = root.querySelector('input[name="id"]');
    var sel = root.querySelector('[data-variant-select]');
    var variants = [];
    try { variants = JSON.parse((root.querySelector('[data-variants]') || {}).textContent || '[]'); } catch (e) {}
    function current() {
      var id = idInput ? Number(idInput.value) : 0;
      return variants.filter(function (v) { return v.id === id; })[0] || variants[0];
    }
    function update() {
      var v = current(); if (!v) return;
      var q = Math.max(1, parseInt(qty && qty.value, 10) || 1);
      if (total) total.textContent = money(v.price * q, fmt);
      var now = root.querySelector('[data-price]'), was = root.querySelector('[data-compare]'), off = root.querySelector('[data-off]');
      if (now) now.textContent = money(v.price, fmt);
      if (was) { was.textContent = v.compare_at_price > v.price ? money(v.compare_at_price, fmt) : ''; }
      if (off) { off.hidden = !(v.compare_at_price > v.price); if (v.compare_at_price > v.price) off.textContent = '%' + Math.round((1 - v.price / v.compare_at_price) * 100) + ' ' + (off.dataset.word || 'İNDİRİM'); }
      var btn = root.querySelector('.muni-add');
      if (btn) btn.disabled = !v.available;
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qty]');
      if (!b || !qty) return;
      e.preventDefault();
      qty.value = Math.min(99, Math.max(1, (parseInt(qty.value, 10) || 1) + Number(b.dataset.qty)));
      update();
    });
    if (qty) qty.addEventListener('input', update);
    if (sel) sel.addEventListener('change', function () {
      idInput.value = sel.value; update();
      var u = new URL(window.location.href); u.searchParams.set('variant', sel.value); history.replaceState({}, '', u.toString());
    });
    update();
  }

  /* ---------- related products (Shopify recommendations) ---------- */
  function loadRelated() {
    document.querySelectorAll('[data-muni-related]').forEach(function (el) {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (t) {
        var d = document.createElement('div'); d.innerHTML = t;
        var fresh = d.querySelector('[data-muni-related]');
        if (fresh && fresh.querySelector('.muni-pcard')) el.innerHTML = fresh.innerHTML;
      }).catch(function () {});
    });
  }

  /* ---------- community cards: still until hover ---------- */
  function initCmAnim() {
    var canHover = window.matchMedia('(hover: hover)').matches;
    document.querySelectorAll('img[data-muni-anim]').forEach(function (img) {
      if (img.dataset.ready) return; img.dataset.ready = '1';
      var card = img.closest('.muni-cm-card') || img;
      if (!canHover) { img.src = img.dataset.muniAnim; return; }
      var pre = new Image(); pre.src = img.dataset.muniAnim;
      function play() { img.src = img.dataset.muniAnim + (img.dataset.muniAnim.indexOf('?') > -1 ? '&' : '?') + 'p=' + Date.now(); }
      function stop() { img.src = img.dataset.muniStill; }
      card.addEventListener('mouseenter', play); card.addEventListener('focus', play);
      card.addEventListener('mouseleave', stop); card.addEventListener('blur', stop);
    });
  }
  document.addEventListener('DOMContentLoaded', initCmAnim);
  document.addEventListener('shopify:section:load', initCmAnim);

  /* ---------- collection sort ---------- */
  document.addEventListener('change', function (e) {
    var s = e.target.closest && e.target.closest('[data-muni-sort]');
    if (!s) return;
    var u = new URL(window.location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page');
    window.location.href = u.toString();
  });

  /* ---------- reels row: mouse drag + arrows ---------- */
  function initReels() {
    document.querySelectorAll('.muni-reels').forEach(function (sec) {
      if (sec.dataset.ready) return; sec.dataset.ready = '1';
      var row = sec.querySelector('.muni-reels__row'); if (!row) return;
      var step = function () { var c = row.querySelector('.muni-reel'); return c ? (c.getBoundingClientRect().width + 22) * 2 : row.clientWidth * .8; };
      var prev = sec.querySelector('.muni-reels__prev'), next = sec.querySelector('.muni-reels__next');
      function upd() {
        if (prev) prev.disabled = row.scrollLeft <= 4;
        if (next) next.disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 4;
      }
      if (prev) prev.addEventListener('click', function () { row.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { row.scrollBy({ left: step(), behavior: 'smooth' }); });
      row.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
      var down = false, sx = 0, sl = 0, moved = false;
      row.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse' || e.button !== 0) return; down = true; moved = false; sx = e.clientX; sl = row.scrollLeft; row.classList.add('is-drag'); });
      window.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - sx; if (Math.abs(dx) > 5) moved = true; row.scrollLeft = sl - dx; });
      window.addEventListener('pointerup', function () { if (!down) return; down = false; row.classList.remove('is-drag'); });
      row.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      row.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  }
  document.addEventListener('DOMContentLoaded', initReels);
  document.addEventListener('shopify:section:load', initReels);

  /* ---------- store locator ---------- */
  function initLocator() {
    var root = document.querySelector('[data-muni-sl]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    var cards = Array.prototype.slice.call(root.querySelectorAll('.muni-sl-card'));
    var search = document.querySelector('[data-muni-sl-search]');
    var count = root.querySelector('[data-muni-sl-count]'), empty = root.querySelector('[data-muni-sl-empty]');
    var filter = 'all';
    function norm(s) { return (s || '').toLocaleLowerCase('tr-TR'); }
    function apply() {
      var q = norm(search && search.value).trim(), n = 0;
      cards.forEach(function (c) {
        var ok = (filter === 'all' || c.dataset.type === filter) && (!q || norm(c.dataset.text).indexOf(q) !== -1);
        c.hidden = !ok; if (ok) n++;
      });
      if (count) count.textContent = n;
      if (empty) empty.hidden = n > 0;
    }
    if (search) search.addEventListener('input', apply);
    document.querySelectorAll('[data-muni-sl-filter]').forEach(function (b) {
      b.addEventListener('click', function () {
        filter = b.dataset.muniSlFilter;
        document.querySelectorAll('[data-muni-sl-filter]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        apply();
      });
    });
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-muni-sl-map]');
      if (!b) return;
      var f = root.querySelector('[data-muni-sl-iframe]');
      if (f) { f.src = 'https://maps.google.com/maps?q=' + encodeURIComponent(b.dataset.muniSlMap + ' Türkiye') + '&z=6&output=embed'; }
      root.querySelectorAll('[data-muni-sl-map]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      var r = f && f.getBoundingClientRect();
      if (r && (r.top < 0 || r.bottom > window.innerHeight)) f.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }
  document.addEventListener('DOMContentLoaded', initLocator);
  document.addEventListener('shopify:section:load', initLocator);

  /* ---------- copy link ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-muni-copy]');
    if (!b) return;
    try { navigator.clipboard.writeText(window.location.href); } catch (err) {}
    b.textContent = b.dataset.done || 'Kopyalandı ✓';
  });

})();
